// The zones of the map (§31 D2): the kind numbers and their names.
//
// Shared by both trees and owned by neither — see `board.ts`. A kind is in a
// command row, a save and the hash, so it is appended to and never
// renumbered. 0 is "no zone" and never a kind.

export const ZONE_FIELD = 1;
export const ZONE_BATTLEFIELD = 2;
export const ZONE_QUARRY = 3;
export const ZONE_DEPOSIT = 4;
export const ZONE_GOLDEN = 5;
export const ZONE_DIAMOND = 6;
export const ZONE_VOID = 7;
export const ZONE_CANYON = 8;
export const ZONE_BROKEN = 9;
/** A sub-zone: rolled inside a Battlefield or Broken Lands, or placed alone. */
export const ZONE_TREASURE = 10;

export type ZoneKind =
  | typeof ZONE_FIELD
  | typeof ZONE_BATTLEFIELD
  | typeof ZONE_QUARRY
  | typeof ZONE_DEPOSIT
  | typeof ZONE_GOLDEN
  | typeof ZONE_DIAMOND
  | typeof ZONE_VOID
  | typeof ZONE_CANYON
  | typeof ZONE_BROKEN
  | typeof ZONE_TREASURE;

/** Every kind, in number order. */
export const ZONE_KINDS: readonly ZoneKind[] = [
  ZONE_FIELD,
  ZONE_BATTLEFIELD,
  ZONE_QUARRY,
  ZONE_DEPOSIT,
  ZONE_GOLDEN,
  ZONE_DIAMOND,
  ZONE_VOID,
  ZONE_CANYON,
  ZONE_BROKEN,
  ZONE_TREASURE
];

/** The name on the wire (`SquareFacts.zone`), keyed by kind. */
export const ZONE_KEY = {
  [ZONE_FIELD]: "field",
  [ZONE_BATTLEFIELD]: "battlefield",
  [ZONE_QUARRY]: "quarry",
  [ZONE_DEPOSIT]: "deposit",
  [ZONE_GOLDEN]: "golden",
  [ZONE_DIAMOND]: "diamond",
  [ZONE_VOID]: "void",
  [ZONE_CANYON]: "canyon",
  [ZONE_BROKEN]: "broken-lands",
  [ZONE_TREASURE]: "treasure-room"
} as const satisfies Record<ZoneKind, string>;

export type ZoneName = (typeof ZONE_KEY)[ZoneKind];

export const isZoneKind = (kind: unknown): kind is ZoneKind =>
  typeof kind === "number" && (ZONE_KINDS as readonly number[]).includes(kind);
